import React from 'react'
import ToggleSwitch from '@SiteComponents/ToggleSwitch'
import './Options.scss'

interface OptionsProps {
  readonly shouldBurnInSubtitles: boolean
  readonly shouldHaveOneAudioFilePerSpeaker: boolean
  readonly audioFormatSelected: boolean
  readonly videoFormatSelected: boolean
  setShouldBurnInSubtitles(newShouldBurnInSubtitles: boolean): void
  setShouldHaveOneAudioFilePerSpeaker(newShouldHaveOneAudioFilePerSpeaker: boolean): void
}

const Options: React.FC<OptionsProps> = props => {
  const {
    shouldBurnInSubtitles,
    shouldHaveOneAudioFilePerSpeaker,
    audioFormatSelected,
    videoFormatSelected,
  } = props

  return (
    <div className="Options">
      <ToggleSwitch
        id="options-switch-burn-in-subtitles"
        checked={shouldBurnInSubtitles}
        onChange={props.setShouldBurnInSubtitles}
        label="Burn subtitles into video files"
        disabled={!videoFormatSelected}
      />
      <ToggleSwitch
        id="options-switch-one-file-per-speaker"
        checked={shouldHaveOneAudioFilePerSpeaker}
        onChange={props.setShouldHaveOneAudioFilePerSpeaker}
        label="One audio file per speaker"
        disabled={!audioFormatSelected}
      />
    </div>
  )
}

export default Options
